import { ref } from "vue";

export const booleanHook = (initialValue = false) => {
  const flag = ref(initialValue);
  const setTrue = () => {
    flag.value = true;
  };
  const setFalse = () => {
    flag.value = false;
  };
  const toggle = () => {
    flag.value = !flag.value;
  };
  return {
    flag,
    setTrue,
    setFalse,
    toggle,
  };
};
